exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper[data-v-253c0e68]{display:flex}", ""]);

// exports
